import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { Calendar } from 'lucide-react';
export function CTAFinal() {
  const scrollToContact = () => {
    document.getElementById('contacto')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-32 bg-pure-black relative overflow-hidden border-t border-white/5" data-id="element-67">
      {/* Cinematic lighting effects */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[300px] bg-electric-yellow/5 rounded-full blur-[100px] pointer-events-none" data-id="element-68" />
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full max-w-xl h-[200px] bg-emerald-glow/10 rounded-full blur-[100px] pointer-events-none" data-id="element-69" />

      <div className="container mx-auto px-6 relative z-10 text-center" data-id="element-70">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="max-w-3xl mx-auto" data-id="element-71">
          <h2 className="text-4xl md:text-5xl font-black text-white mb-8 leading-tight" data-id="element-72">
            ¿Listo para llenar tus bahías con{' '}
            <span className="text-electric-yellow" data-id="element-73">clientes de alto valor</span>
            ?
          </h2>
          <p className="text-xl text-gray-400 mb-12" data-id="element-74">
            Deja de perder dinero por tener elevadores vacíos. Convierte tu
            taller en la autoridad indiscutible de tu ciudad.
          </p>

          <div className="flex flex-col items-center gap-6" data-id="element-75">
            <Button onClick={scrollToContact} className="w-full sm:w-auto text-lg px-10 py-5" data-id="element-76">
              OBTENER MI REVISIÓN DE VISIBILIDAD
            </Button>

            <a href="https://calendar.app.google/gDsqAVqmwUYm" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-gray-400 hover:text-electric-yellow transition-colors text-sm font-medium" data-id="element-77">
              <Calendar className="w-4 h-4" data-id="element-78" />O agenda tu cita directamente en
              Google Calendar
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}